import { Button, Space } from 'antd';
import VoteContent from './apple';
import NoticeContent from './android';
import { useState } from 'react';
const tabMap = {
  apple: {
    name: '苹果',
    value: 'apple',
  },
  android: {
    name: '安卓',
    value: 'android',
  },
};

type TValue = 'apple' | 'android';

const VoteActivityPage: React.FC = () => {
  const [active, setActive] = useState(tabMap.apple.value);

  const onTabChange = (value: TValue) => {
    console.log(value, 'value');
    if (value === active) return;
    setActive(value);
  };

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        {Object.values(tabMap).map((tab) => {
          // return <div key={tab.value}>{tab.name}</div>;
          const value = tab.value as TValue;
          const type = active === tab.value ? 'primary' : 'default';
          return (
            <Button
              key={tab.value}
              type={type}
              onClick={() => onTabChange(value)}
            >
              {tab.name}
            </Button>
          );
        })}
      </Space>
      <div style={{ display: active === tabMap.apple.value ? 'block' : 'none' }}>
        <VoteContent />
      </div>
      <div
        style={{ display: active === tabMap.android.value ? 'block' : 'none' }}
      >
        <NoticeContent />
      </div>
    </>
  );
};

export default VoteActivityPage;
